import { filter, fromEvent, map, partition } from 'rxjs';

const searchSubmitElement = document.querySelector('[data-search-submit]');
const searchInput = document.getElementById('blog_typeahead_input');
const searchForm = searchInput.closest('form');

/**
 * Opens a new browser tab with the search results for the given search text.
 * @param {string} searchText - The text to search for.
 */
const openSearchUrl = (searchText) => {
  const params = new URLSearchParams({ SearchText: searchText, ToPage: 'communities' });
  window.open(`Search?${params}`, '_blank');
};

/**
 * Toggles the typeahead error container and the 'error' class on the closest form.
 * @param {boolean} show - If true, shows the error; otherwise hides it.
 */
const toggleErrorContainer = function (show) {
  const errorContainer = document.getElementById('blog_typeahead_error');
  const form = errorContainer?.closest('form');
  if (!form) { return; }
  form.classList.toggle('nhs-c-typeahead__form--error', !!show);
};

// observables for search submit and form click outside
const formOutClick$ = fromEvent(document, 'click').pipe(filter((event) => (
  !event.target.matches('[data-search-submit]') && !searchForm.contains(event.target))))
const searchSubmit$ = fromEvent(searchSubmitElement, 'click').pipe(
  filter(event => event.target?.matches('[data-search-submit]')),
  map(() => document.getElementById('blog_typeahead_input').value.trim())
);
const [submitSearchText$, displayError$] = partition(
  searchSubmit$,
  (searchValue) => searchValue
);

submitSearchText$.subscribe(openSearchUrl);
displayError$.subscribe(() => toggleErrorContainer(true));
formOutClick$.subscribe(() => toggleErrorContainer(false));